var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay_jump_div"},[_c('van-loading',{attrs:{"type":"spinner","color":"#edf2fa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }